import { ReactNode } from 'react';

/**
 * Small uppercase section label with a short leading rule — borrowed from the
 * public docs site's "eyebrow" treatment, themed with the app's color tokens so
 * it adapts to light/dark mode.
 */
export function SectionEyebrow({ children }: { children: ReactNode }) {
  return (
    <span className="inline-flex items-center gap-2.5 text-[11px] font-semibold uppercase tracking-[0.08em] text-[var(--color-text-muted)]">
      <span
        aria-hidden
        className="inline-block h-px w-5 bg-current opacity-40"
      />
      {children}
    </span>
  );
}

export default SectionEyebrow;
